import { getFirstDayCurrentMonth, getLastDayCurrentMonth } from "../../../utils/Custom";
import { getDateHour } from "../../../utils/DateHour";
import apiConnection from "../../Connection";
import { clearEvidences, processRequest, setError, setEvidences } from "./slice";




export const loadEvidences = (folio) => {
    return async (dispatch, getState) => {
        // dispatch(clearRequestsPDF());
        dispatch(clearEvidences());
        dispatch(processRequest());
        await apiConnection.get(`/Evidences/getEvidencesByID/${folio}`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setEvidences({
                        items: response.data.data,
                    })
                );
            }
        }).catch(function (error) {
            // console.log(error);
            dispatch(setError())
        });
    }
}


export const uploadEvidence = (reference, userupload, fileItem, meta) => async (dispatch) => {
    const { fecha, hora, fuente } = await getDateHour();
    const formData = new FormData();

    // console.log(meta);

    formData.append('file', fileItem.file);
    formData.append('module', meta.module);
    formData.append('entity_type', meta.entity_type);
    formData.append('entity_id', meta.entity_id);
    formData.append('reference', reference);
    formData.append('userupload', userupload);
    formData.append('dateupload', fecha);
    formData.append('hourupload', hora);

    try {
        const res = await apiConnection.post('/Evidences/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        dispatch(loadEvidences(reference))
        return { ok: true, data: res.data };

    } catch (err) {
        return { ok: false, error: err.message };
    }
};